import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { PERMISSION_GROUP_ARRAY } from "context/auth";
import { getPermissionActionLabel } from "shared";

import CountBadgeWithTooltip from "../CountBadgeWithTooltip";
import { RolePermissionsProps } from "./types";

const RolePermissions = ({ permissions }: RolePermissionsProps) => {
    const { gray700 } = colors;

    const { t } = useTranslation();

    const groupsWithFilteredPermissions = PERMISSION_GROUP_ARRAY.map(
        groupObj => {
            return {
                ...groupObj,
                permissions: groupObj.permissions.filter(groupPerm =>
                    permissions.includes(groupPerm)
                )
            };
        }
    );

    const filteredGroups = groupsWithFilteredPermissions.filter(
        group => group.permissions.length > 0
    );

    return (
        <CountBadgeWithTooltip
            count={permissions.length}
            tooltip={
                <ul
                    css={css({
                        maxHeight: "240px",
                        overflowY: "auto",
                        marginRight: "-16px",
                        paddingRight: "16px",

                        "& > li + li": {
                            marginTop: "24px"
                        },

                        "&::-webkit-scrollbar-thumb": {
                            borderColor: gray700
                        }
                    })}
                >
                    {filteredGroups.map(({ groupId, permissions }) => (
                        <li
                            key={groupId}
                            css={css({
                                h6: {
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    lineHeight: "20px",
                                    letterSpacing: "0.1px",
                                    marginBottom: "4px"
                                }
                            })}
                        >
                            <h6>{t(`Permission groups##${groupId}`)}</h6>

                            <ul
                                css={css({
                                    paddingLeft: "16px",

                                    "& > li": {
                                        listStyle: "disc"
                                    }
                                })}
                            >
                                {permissions.map(permission => (
                                    <li key={permission}>
                                        {getPermissionActionLabel(
                                            permission,
                                            t
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            }
        />
    );
};

export default RolePermissions;
